export enum SubscriptionStatusEnumFR {
  CREEE = 'CREEE',
  RECUE = 'RECUE',
  VALIDEE = 'VALIDEE',
  ANULEE = 'ANULEE',
  TRANSFORMEE = 'TRANSFORMEE',
}

export enum SubscriptionStatusEnum {
  CREATED = 'CREATED',
  RECEIVED = 'RECEIVED',
  VALIDATED = 'VALIDATED',
  CANCELED = 'CANCELED',
  TRANSFORMED = 'TRANSFORMED',
}

export const translateSubscriptionStatus = (ss: SubscriptionStatusEnumFR): SubscriptionStatusEnum => {
  switch (ss) {
    case SubscriptionStatusEnumFR.CREEE:
      return SubscriptionStatusEnum.CREATED;
    case SubscriptionStatusEnumFR.RECUE:
      return SubscriptionStatusEnum.RECEIVED;
    case SubscriptionStatusEnumFR.VALIDEE:
      return SubscriptionStatusEnum.VALIDATED;
    case SubscriptionStatusEnumFR.ANULEE:
      return SubscriptionStatusEnum.CANCELED;
    case SubscriptionStatusEnumFR.TRANSFORMEE:
      return SubscriptionStatusEnum.TRANSFORMED;
  }
};
